<template>
  <div class="docker-server">
    <iframe name="iframeChild" id="iframeChild" v-bind:src="getPageUrl"
            frameborder="0" scrolling="auto" ref="iframeDom">
    </iframe>
  </div>
</template>

<script>
  import request from '../../api/nesting';

  export default {
    name: 'server',
    data() {
      return {
        getPageUrl: ''
      };
    },
    mounted() {
      request.getGsnPageUrlInfo({
        gsnParam: 'affiliation'
      }).then(res => {
        if (res.status) {
          this.getPageUrl = res.data.gsnReturnUrl;
        }
      });
    }
  };
</script>

<style lang="scss" scoped>
  /** iframe样式 */
  #iframeChild {
    width: 100%;
    height: calc(100vh - 125px);
  }
</style>